import { Box } from '@mui/material';
import { useTitle } from 'shared/hooks';
import { UserInfo } from 'shared/types';
import { ProductsSummary } from './products-summary';
import { ProductsTable } from './products-table';
import { determineIsAdmin } from '../shared/utility';
import { useCallback, useState } from 'react';

interface ProductsPageProps {
  user: UserInfo;
}
export function ProductsPage({ user }: ProductsPageProps) {
  useTitle('Products');

  const isAdmin = determineIsAdmin(user);
  const [isProductSummaryCollapsed, setIsProductSummaryCollapsed] = useState<boolean>(isAdmin);

  const toggleIsCollapsed = useCallback(() => {
    // avoiding the toggle to show the y-scroll for 1.5 sec
    try {
      if (isProductSummaryCollapsed) {
        document.body.style.overflowY = 'hidden';
      }
      setIsProductSummaryCollapsed(!isProductSummaryCollapsed);
      setTimeout(() => {
        document.body.style.overflowY = '';
      }, 1500);
    } catch (e) {
      console.error(e);
    }
  }, [isProductSummaryCollapsed, setIsProductSummaryCollapsed]);

  return (
    <Box>
      <ProductsSummary isCollapsed={isProductSummaryCollapsed} toggleIsCollapsed={toggleIsCollapsed} />
      <ProductsTable user={user} isProductSummaryCollapsed={isProductSummaryCollapsed} />
    </Box>
  );
}
